import { CompletionRateData, FormSlug } from "../types";

export const atLeastOneFormIsComplete = (
  completionRateData: CompletionRateData,
) => {
  /**
   * The Content Promotion form should not be included in determining if at least one form is completed.
   */
  const filteredCompletionRates = completionRateData.completion_rates.filter(
    ({ form_slug: formSlug }) => formSlug !== FormSlug.ContentPromotion,
  );
  return filteredCompletionRates.some(
    ({ completion_rate: completionRate }) => completionRate === 1,
  );
};
